<template>
  <div>
    <v-row>
      <v-col class="py-1" cols="12" sm="6">
        <v-select
          v-model="selectedPersonnelSurvey"
          :class="appBar ? 'mt-1' : ''"
          :item-text="item => itemText(item.end, item.name)"
          :items="personnelSurveys"
          :label="$t('reports.personnel_survey')"
          :no-data-text="$t('reports.no_surveys_with_answers')"
          clearable
          dense
          hide-details
          item-value="key"
          outlined
        ></v-select>
      </v-col>
      <v-col v-if="$vuetify.breakpoint.xsOnly" class="py-1" cols="12">
        <survey-share-selector
          v-model="selectedPersonnelSurveyShares" :class="appBar ? 'mt-1' : ''"
          :error="selectedPersonnelSurveyShares.length === 0 && selectedManagementSurveyShares.length === 0 && !$isPaidTenant"
          :items="personnelSurveyShares"
          :label="$t('reports.personnel_share')"
          :loading="loadingPersonnelSurveyShares"
          :rules="[v => (($isPaidTenant && v.length >= 0) || (!$isPaidTenant && v.length > 0)) || $t('reports.choose_target_group')]"
          clearable
          dense
          hide-details
          item-text="name"
          item-value="key"
          multiple
          outlined
        />
      </v-col>

      <v-col class="py-1" cols="12" sm="6">
        <v-divider v-if="$vuetify.breakpoint.xsOnly" class="mb-2"/>
        <v-select
          v-model="selectedManagementSurvey"
          :class="appBar ? 'mt-1' : ''"
          :item-text="item => itemText(item.end, item.name)"
          :items="managementSurveys"
          :label="$t('reports.management_survey')"
          :no-data-text="$t('reports.no_surveys_with_answers')"
          clearable
          dense
          hide-details
          item-value="key"
          outlined
        ></v-select>
      </v-col>
      <v-col v-if="$vuetify.breakpoint.xsOnly" class="py-1" cols="12">
        <survey-share-selector
          v-model="selectedManagementSurveyShares" :class="appBar ? 'mt-1' : ''"
          :error="selectedManagementSurveyShares.length === 0 && selectedPersonnelSurveyShares.length === 0 && !$isPaidTenant"
          :items="managementSurveyShares"
          :label="$t('reports.management_share')"
          :loading="loadingManagementSurveyShares"
          :rules="[v => (($isPaidTenant && v.length >= 0) || (!$isPaidTenant && v.length > 0)) || $t('reports.choose_target_group')]"
          clearable
          dense
          hide-details
          item-text="name"
          item-value="key"
          multiple
          outlined
        />
      </v-col>
    </v-row>
    <v-row v-if="$vuetify.breakpoint.smAndUp">
      <v-col class="py-2" cols="12" sm="6">
        <survey-share-selector
          v-model="selectedPersonnelSurveyShares" :class="appBar ? 'mt-1' : ''"
          :error="selectedPersonnelSurveyShares.length === 0 && selectedManagementSurveyShares.length === 0 && !$isPaidTenant"
          :items="personnelSurveyShares"
          :label="$t('reports.personnel_share')"
          :loading="loadingPersonnelSurveyShares"
          :rules="[v => (($isPaidTenant && v.length >= 0) || (!$isPaidTenant && v.length > 0)) || $t('reports.choose_target_group')]"
          clearable
          dense
          hide-details
          item-text="name"
          item-value="key"
          multiple
          outlined
        />
      </v-col>
      <v-col class="py-2" cols="12" sm="6">
        <survey-share-selector
          v-model="selectedManagementSurveyShares" :class="appBar ? 'mt-1' : ''"
          :error="selectedManagementSurveyShares.length === 0 && selectedPersonnelSurveyShares.length === 0 && !$isPaidTenant"
          :items="managementSurveyShares"
          :label="$t('reports.management_share')"
          :loading="loadingManagementSurveyShares"
          :rules="[v => (($isPaidTenant && v.length >= 0) || (!$isPaidTenant && v.length > 0)) || $t('reports.choose_target_group')]"
          clearable
          dense
          hide-details
          item-text="name"
          item-value="key"
          multiple
          outlined
        />
      </v-col>
    </v-row>
  </div>


</template>

<script>
import teamApi from "@/api/team";
import surveyShareApi from "@/api/surveyshare";
import SurveyShareSelector from "@/components/Tenant/Reports/SurveyShareSelector";
import dayjs from "dayjs";

export default {
  name: 'SurveysSelector',
  components: {SurveyShareSelector},
  data() {
    return {
      teams: [],
      loadingPersonnelSurveyShares: false,
      loadingManagementSurveyShares: false,
    }
  },
  props: {
    appBar: {
      type: Boolean,
      default: false,
    },
    managementSurveys: {
      type: Array,
      default: null,
    },
    personnelSurveys: {
      type: Array,
      default: null,
    },
  },
  computed: {
    selectedPersonnelSurvey: {
      get() {
        return this.$store.state.selectedPersonnelSurvey;
      },
      set(value) {
        this.$store.commit('setSelectedPersonnelSurvey', value);
        this.$store.commit('editReportFilters', {selectedPersonnelSurveyShares: []});
      },
    },
    selectedManagementSurvey: {
      get() {
        return this.$store.state.selectedManagementSurvey;
      },
      set(value) {
        this.$store.commit('setSelectedManagementSurvey', value);
        this.$store.commit('editReportFilters', {selectedManagementSurveyShares: []});
      },
    },
    personnelSurveyShares() {
      return this.$store.state.reportFilters.personnelSurveyShares;
    },
    managementSurveyShares() {
      return this.$store.state.reportFilters.managementSurveyShares;
    },
    selectedPersonnelSurveyShares: {
      get() {
        return this.$store.state.reportFilters.selectedPersonnelSurveyShares;
      },
      set(value) {
        if (value.length > 1 && !this.$isPaidTenant) {
          this.$showWarningNotification(this.$t('reports.selected_share_free_warning'));
          return;
        }
        this.$store.commit('editReportFilters', {selectedPersonnelSurveyShares: value});
      },
    },
    selectedManagementSurveyShares: {
      get() {
        return this.$store.state.reportFilters.selectedManagementSurveyShares;
      },
      set(value) {
        this.$store.commit('editReportFilters', {selectedManagementSurveyShares: value});
      },
    },
  },
  methods: {
    itemText(end = undefined, name) {
      const ongoing = (end !== undefined && dayjs().isAfter(end)) ? false : true;
      const nameField = (name) ? ' ' + name : '';
      const asterisk = ongoing ? ` [${this.$t('surveys.survey_ongoing')}]` : '';
      return this.$formatMonthAndYearLong(end) + nameField + asterisk;
    },
    async reloadTeams() {
      try {
        const response = await teamApi.getTeams();
        if (response) {
          this.teams = response;
        }
      } catch (e) {
        this.$handleApiError(e, this.$t('teams.errors.error_loading'));
      }
    },
    async getPersonnelSurveyShares() {
      this.$store.commit('editReportFilters', {personnelSurveyShares: []});
      if (!this.selectedPersonnelSurvey) {
        return;
      }
      this.loadingPersonnelSurveyShares = true;
      try {
        this.$store.commit('editReportFilters', {
          personnelSurveyShares: await surveyShareApi.getSurveyShares(this.selectedPersonnelSurvey)
        })
      } catch (e) {
        console.error(e)
        this.$handleApiError(e, this.$t('reports.errors.error_loading'));
      }
      this.loadingPersonnelSurveyShares = false;
    },
    async getManagementSurveyShares() {
      this.$store.commit('editReportFilters', {managementSurveyShares: []});
      if (!this.selectedManagementSurvey) {
        return;
      }
      this.loadingManagementSurveyShares = true;
      try {

        this.$store.commit('editReportFilters', {
          managementSurveyShares: await surveyShareApi.getSurveyShares(this.selectedManagementSurvey)
        })
      } catch (e) {
        console.error(e)
        this.$handleApiError(e, this.$t('reports.errors.error_loading'));
      }
      this.loadingManagementSurveyShares = false;
    },

  },
  mounted() {
    if (this.selectedPersonnelSurvey && this.personnelSurveyShares.length === 0) {
      this.getPersonnelSurveyShares();
    }
    if (this.selectedManagementSurvey && this.managementSurveyShares.length === 0) {
      this.getManagementSurveyShares();
    }
  },
  watch: {
    [`selectedPersonnelSurvey`]() {

      this.getPersonnelSurveyShares();
    },
    [`selectedManagementSurvey`]() {
      this.getManagementSurveyShares();
    },
  },
};
</script>

<style scoped></style>
